export default __webpack_public_path__ + "static/media/Banner - Hybridshell - Keychain - Black.100471f6.jpg";